import { createContext, useContext, useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const YouProcessThemeContext = createContext({
  primaryColor: undefined,
  setPrimaryColor: () => undefined,
});

export const YouProcessThemeProvider = ({ children }) => {
  const [primaryColor, setPrimaryColor] = useState(undefined);

  const updatePrimaryColor = useCallback((color) => {
    setPrimaryColor(color || undefined);
  }, []);

  const value = useMemo(
    () => ({ primaryColor, setPrimaryColor: updatePrimaryColor }),
    [primaryColor, updatePrimaryColor],
  );

  return (
    <YouProcessThemeContext.Provider value={value}>
      {children}
    </YouProcessThemeContext.Provider>
  );
};

YouProcessThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useYouProcessTheme = () => useContext(YouProcessThemeContext);

export default YouProcessThemeProvider;
